import React from 'react';
import Button from "../../../components/common/Button";
import Input from "../../../components/common/Input";
import { useNavigate } from "react-router-dom";
import { changePassword, clearLoginData } from "../../../store/slices/api/auth/loginSlice";
import Main from '../../../components/HOC/Main';
import { NAVIGATION } from '../../../lib/navigation';
import useApiRequest from '../../../store/slices/hook/useApiRequest';

export default function ChangePasswordPage() {
    const navigate = useNavigate();

    const afterAPICall = (response) => {
        navigate(NAVIGATION.AUTH_NAVIGATION.LOGIN);
    };

    const { isLoading, control, handleSubmit, watch } = useApiRequest({
        apiAction: changePassword,
        setValueAction: clearLoginData,
        afterAPICall,
    });

    return (
        <Main crumbs={[{ title: "Setting" }, { title: "Change Password" }]}>
            <div className="flex justify-center items-center p-10 bg-gray-100 ">
                <div className="w-full max-w-lg bg-white shadow-xl rounded-lg p-8 ">
                    <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">Change Password</h2>
                    <p className="text-gray-600 text-center mb-6">
                        Please enter your current password and your new password to proceed.
                    </p>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="grid grid-cols-1 gap-4">
                            <Input
                                control={control}
                                name="old_password"
                                rules={{ required: "Current password is required" }}
                                type="password"
                                label="Current Password"
                                className="w-full"
                            />
                        </div>
                        <div className="grid grid-cols-1 gap-4 mt-4">
                            <Input
                                control={control}
                                name="new_password"
                                rules={{ required: "New password is required" }}
                                type="password"
                                label="New Password"
                                className="w-full"
                            />
                        </div>
                        <div className="grid grid-cols-1 gap-4 mt-4">
                            <Input
                                control={control}
                                name="conf_password"
                                rules={{
                                    required: "Confirmation password is required",
                                    validate: (value) => {
                                        if (watch('new_password') !== value) {
                                            return "Passwords do not match";
                                        }
                                    },
                                }}
                                type="password"
                                label="Confirm New Password"
                                className="w-full"
                            />
                        </div>
                      
                          <Button isLoading={isLoading} className="w-full my-6">
                            Change Password
                        </Button>
                    </form>
                </div>
            </div>
        </Main>
    );
}
